const exports = {
  // eslint-disable-next-line spaced-comment
/////////////////
  LanguageSwitchToKeys: () =>
    import(
      /* webpackChunkName: "LanguageSwitchToKeysHidden" */ '@/js/components/Navigation/LanguageSwitchToKeysHidden.js'
    ),
  // eslint-disable-next-line spaced-comment
///////////
//////////////////////////////////////////
/////////////////////////////
///////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////
////////////////////////////////////////////
////////////
}

export const LanguageSwitchToKeys = exports.LanguageSwitchToKeys
